// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--mp-JgROl","widget":"widget--mp-c1EuC"};